<template>
    <div ref="priceTableRequestDialog">
        <app-dialog :title="tb('Pedido de Tabela de Preços')" width="800px" @input="dialogInput($event)" v-bind="{ ...$attrs }">
            <template v-slot:content>
                <v-row class="d-flex flex-column">
                    <v-col cols="12">
                        <v-form ref="form" lazy-validation>
                            <v-text-field v-model="form.name" required :rules="[rules.required]" type="text" :label="$t('userDetails.name')" autocomplete="name" autofocus @keyup.enter="submitRequest" data-cy="name"> </v-text-field>
                            <v-text-field v-model="form.email" required :rules="[rules.required, rules.email]" type="email" label="Email" autocomplete="email" @keyup.enter="submitForm" data-cy="email"> </v-text-field>
                            <v-textarea :label="$t('priceTable.message')" v-model="form.message" required :rules="[rules.message_length, rules.required]" dense rows="5"></v-textarea>
                        </v-form>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:buttons="{}">
                <v-row>
                    <v-col cols="12" md="6" sm="6">
                        <v-btn text outlined class="myprovet-btn-cancel" @click="$emit('onCancel')" data-cy="app-dialog-cancel-btn"> {{ $t('common.cancel') }} </v-btn>
                    </v-col>

                    <v-col cols="12" md="6" sm="6">
                        <v-btn text class="myprovet-btn-ok" @click="submitRequest()" data-cy="app-dialog-submit-btn"> {{ $t('sendAccount.send') }} </v-btn>
                    </v-col>
                </v-row>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { axios } from '@/Services/Backend';

export default {
    data() {
        return {
            form: {
                name: '',
                email: '',
                message: '',
                errors: null,
            },

            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
                message_length: (value) => value.length <= 255 || i18n.t('comment.maxLength'),
                email: function (value) {
                    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return value && re.test(value) ? true : i18n.t('userDetails.rules.invalidEmail');
                },
            },
        };
    },

    created() {
        this.form.name = this.getBranchName;
        this.form.email = this.getBranchEmail;
    },

    computed: {
        ...mapStores(useBranchStore, useUserStore),

        getBranchName() {
            return this.branchStore.branch?.name || this.unknownValue;
        },

        getBranchEmail() {
            return this.branchStore.branch?.emails || this.unknownValue;
        },
    },

    methods: {
        submitRequest() {
            if (!this.$refs.form.validate()) return;

            const dataToSend = {
                branch_id: this.branchStore.branch.id,
                name: this.form.name,
                email: this.form.email,
                message: this.form.message,
            };

            axios
                .post('/api/products/price-table-request', dataToSend)
                .then(() => {
                    this.form.errors = null;
                    this.showSuccess(this.$t('priceTable.sent'));
                    this.$emit('onCancel', false);
                })
                .catch((error) => {
                    const errors = error.response.data.errors;

                    this.form.errors = errors;
                    this.showError(this.$t('priceTable.error'));
                });
        },

        dialogInput(event) {
            this.$emit('onCancel', event);
        },
    },
};
</script>
